const freeTrialSubject = 'Scribl plans & upgrade options';
const freeTrialBody = `Hi Scribl team,

I've been using Scribl on a free trial and would like to learn more about upgrading to a paid plan.

Optional context:
  - Organization name:
  - Approx. number of hosts:
  - Type of use (team meetings, events, etc.):

Looking forward to your guidance.

Best,
[Your name]`;

const freeTrialMailtoHref = `mailto:info@scribl.co?subject=${encodeURIComponent(
  freeTrialSubject
)}&body=${encodeURIComponent(freeTrialBody)}`;

export { freeTrialMailtoHref };
